<template>
    <div id="modal" class="modal modal_size">
        <a
            href="javascript:"
            class="ui_close"
            type="button"
            rel="modal:close"
            @click="$emit('close')"
        >
            <span class="sr_only">popup close</span>
        </a>

        <dl class="modal_content alert_msg ">
            <dt class="ellipsis">
                <slot name="header">
                    TrustNet Solution needs to be installed!
                </slot>
            </dt>
            <dd>
                If automatic installation does not work,<br>
                please manually download the plugin and install it.<br>
                After the installation, please restart the browser.        
            </dd>
        </dl>
        <div class="btn_modal_wrap set_2"><!-- 200512수정(class추가) -->
            <div class="btn_right">
                <a href="javascript:" class="btn_white" @click="$emit('close')">Cancel</a>
<!-- CB 22.9.19 client 교체 -->                
<!--                 <a -->
<!--                     class="btn_blue" -->
<!--                     @click="download" -->
<!--                     href="http://skp.samsungcsportal.com/basis/certificate/setup/TrustNET_Web_Toolkit_for_SecuiGSPN_v4.0.0.7.exe" -->
<!--                 > -->
                <a
                    class="btn_blue"
                    @click="download"
                    href="/static/setup/TrustNet_Cert_WEBCLIENT_v1.0.0.9.exe"
                >
                    Download
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    methods: {
        download() {
            this.$emit('close');
        },
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/certificate/CertInstallPopup.vue